import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

import 'seia'
import "bsky-embed/dist/bsky-embed.es.js"

console.info("Bridgetown is loaded!")
